import {
  AdditionalOption,
  OldAdditionalOption,
  TRoomDetail,
} from '@/entities/room'
import { cn } from '@/shared/lib'
import { TextButton } from '@/shared/ui'

import { Heading } from '../common'
import { OptionDialogTrigger, OptionList } from './option-dialog'

export type Props = Pick<TRoomDetail, 'basicOptions' | 'missingOptions'> & {
  additionalOptions: (AdditionalOption | OldAdditionalOption)[]
}

const MAX_COUNT = 9

export const RoomOption = ({
  basicOptions,
  additionalOptions,
  missingOptions,
}: Props) => {
  const slicedOptions = additionalOptions.slice(0, MAX_COUNT)

  const hasBasicOptions = basicOptions.length > 0
  const hasAdditionalOptions = additionalOptions.length > 0

  const totalCount = basicOptions.length + additionalOptions.length

  return (
    <section className="space-y-4">
      {hasBasicOptions && (
        <div className={cn('space-y-4', hasAdditionalOptions && 'mb-20')}>
          <Heading>기본 옵션</Heading>
          <OptionList options={basicOptions} />
        </div>
      )}

      {hasAdditionalOptions && (
        <div className="space-y-4">
          <Heading>추가 옵션</Heading>
          <OptionList options={slicedOptions} />
        </div>
      )}

      <OptionDialogTrigger
        basicOptions={basicOptions}
        additionalOptions={additionalOptions}
        missingOptions={missingOptions}
      >
        <TextButton size="small" underline color="black" weight="normal">
          옵션 {totalCount}개 전체보기
        </TextButton>
      </OptionDialogTrigger>
    </section>
  )
}
